import { ReactNode } from 'react';
import styled from 'styled-components';

import { NeonEdge } from '@sorare/core/src/atoms/ui/NeonEdge';
import { Bezel } from '@sorare/core/src/atoms/ui/bezels/Bezel';

const StyledBezel = styled(Bezel)`
  position: relative;
  padding: var(--double-unit);
  flex: 1;
  width: 100%;
  max-width: 100%;
`;
const StyledNeonEdge = styled(NeonEdge)`
  position: absolute;
  inset: 0;
`;

type Props = { color: string; children: ReactNode };
export const TutorialBezel = ({ color, children }: Props) => {
  return (
    <StyledBezel background="conic-gradient(from 90deg at 3px 3px, var(--c-nd-50) 25%, var(--c-black) 0) 0 0/5px 5px">
      <StyledNeonEdge color={color} />
      {children}
    </StyledBezel>
  );
};
